import { Filter } from 'src/utils/composeFilter.ts';

export const updateFilter = (filter: Filter, searchParams: URLSearchParams): URLSearchParams => {
    Object
        .entries(filter)
        .forEach(([name, v]) => {
            if (v.length === 0) {
                searchParams.delete(name);
            } else {
                searchParams.set(name, JSON.stringify(v));
            }
        });
    return searchParams;
};
